// @ts-nocheck

import { HexpertResultData, HexpertResultSummaryItemData } from '../../types/hexpertResultTypes';
import Axios from 'axios';
import { PageForms } from '../../types/hexpertTypes';
import { HexpertState } from '../../contexts/HexPertProvider';
import { Hexpert as endpoints } from '@services/endpoints';

export type GeneratePdfDocumentProps = {
  data?: HexpertResultData;
  resultUrl?: string;
  email?: string;
  pageId?: string;
  title?: string;
  productType?: PageForms;
  state?: HexpertState;
  internalMail?: string;
};

export const generatePdfDocument = async ({
  data,
  resultUrl,
  email,
  pageId,
  title,
  productType,
  callback,
  state,
  internalMail,
}: GeneratePdfDocumentProps) => {
  const url = window?.location?.protocol + '//' + window?.location?.hostname;
  let columns = Array.from(new Set(data.Summary?.FormDataItems.map((item) => item.Slide)));
  const currentForm = state.pageProps?.MappedForms?.find(
    (form) => form?.formGuid === state.productResult?.FormGuid
  );

  let SummaryColumns = [];
  columns.forEach((column: string) => {
    const showColumn = data?.Summary?.FormDataItems.filter(
      (item) => item.Slide === column && item?.FieldValue?.length > 0
    )?.length;
    if (showColumn) {
      SummaryColumns.push({
        name: column,
        values: data.Summary?.FormDataItems.filter(
          (item: HexpertResultSummaryItemData) => item.Slide === column && item.FieldValue
        ).map((item) => {
          const mapValueFromBlock = state.pageProps?.fieldsToCheckInResult?.includes(
            item?.FieldName
          );
          let answerCaption = '';
          if (mapValueFromBlock) {
            currentForm.sections?.forEach((section) =>
              section.questions?.forEach((question) => {
                if (question.FieldId === item?.FieldName) {
                  answerCaption = question?.Options?.find(
                    (option) => option.Value === item?.FieldValue
                  )?.Caption;
                }
              })
            );
          }
          return {
            Label: item.Label,
            Value:
              answerCaption?.length > 0
                ? `${answerCaption} ${item?.unit}`
                : `${item.FieldValueText} ${item.unit}`,
          };
        }),
      });
    }
  });

  const pdf_data = {
    ResultUrl: resultUrl,
    ResultSubTitle: data.Summary?.LocalizedTranslationResources?.WeFitResultTitle,
    ResultTitle:
      data.Summary?.LocalizedTranslationResources?.WeFitProductNamePrefix +
      data.ProductDetails?.Title,
    Images: {
      mainImage: data.ProductDetails?.ImageUrl,
      extraImages:
        data.Product.Variant.VideoImages?.map((image: HexpertResultVideoImages) => image.Url) ?? [],
    },
    Intro: {
      Description: data.ProductDetails?.Description,
      Title: data.ProductDetails?.Title,
      QuoteText: data.Product?.WefitProductRequestQuote,
      QuoteQuestion: data.Summary?.LocalizedTranslationResources?.WeFitSatisfiedWithYourProduct,
    },
    TopFeatures: data.Product.Features,
    WefitCaseStoriesTitle: data.Summary.LocalizedTranslationResources.WefitCaseStoriesTitle,
    TopReasons: {
      Title: data.Product?.WefitProductTopReasons,
      Reasons: data.Product.TopReasons,
    },
    Documents: {
      Title: data?.Summary?.LocalizedTranslationResources?.WeFitRelatedContentTitle,
      Links: data.Product.Links?.map((link) => {
        return {
          ...link,
          Url: url + link.Url,
        };
      }),
    },
    DidYouKnow: {
      Title: data.Product?.WefitProductDidYouKnow,
      Text: data.Product?.DidYouKnowText,
    },
    Summary: {
      PositionLabel: data.Summary?.LocalizedTranslationResources?.WefitBlockPosition,
      SummaryType: productType?.title,
      Columns: SummaryColumns,
    },
    CaseStories: data.Product.CaseStories.map((story, i) => {
      return {
        Title: story.Title,
        Description: story.Description,
        Image: story.Image,
      };
    }),
  };

  // Create pdf on server, returned as base64
  const pdfBlob = await Axios.post(endpoints.createHexpertPdf, pdf_data);

  Axios.post(endpoints.mailResult, pdfBlob.data, {
    params: {
      mailTo: email,
      pageId: pageId,
      title: title,
      resultUrl: resultUrl,
      ...(internalMail ? { bcc: internalMail } : {}),
    },
    headers: {
      'Content-Type': 'text/plain',
    },
  }).then((res) => {
    callback && callback();
  });
};
